<span class="u-display-block u-font-weight-700 u-font-size-14">{{title}}</span>
<app-unordered-list-with-price [featureListWithPrice]="config"></app-unordered-list-with-price>
